import { useFela } from 'react-fela';

import { GroupItem } from '@/modules/groups/components/GroupItem';
import { useGroupsWithLocalizedAllUsersGroup } from '@/modules/groups/hooks/useGroupsWithLocalizedAllUsersGroup';
import type { GroupWithPermissions } from '@/modules/groups/types';
import { Text } from '@/modules/ui';

import { VAULT_ACCESS_ROLES } from '../../../utils';
import * as felaRules from './VaultGroupsList.rules';

export interface VaultGroupsListProps {
    value: GroupWithPermissions[];
    onRemove: (id: GroupWithPermissions['id']) => void;
    onUpdate: (group: GroupWithPermissions) => void;
}

/**
 * The vaults' own stand-in for `FormFieldGroups`, which watches the secret form's passkey field to
 * decide whether a passkey-only role is selectable — a field a vault form does not have. A vault never
 * offers that role anyway, hence `hasPasskey={false}`.
 */
export const VaultGroupsList = ({ value, onRemove, onUpdate }: VaultGroupsListProps) => {
    const groups = useGroupsWithLocalizedAllUsersGroup(value);

    const { css } = useFela();

    if (!groups.length) {
        return null;
    }

    return (
        <div className={css(felaRules.container)}>
            <Text variant='ParagraphSmallMedium' elementType='ul' customStyle={felaRules.list}>
                {groups.map(group => (
                    <GroupItem
                        key={group.id}
                        {...group}
                        editable
                        hasPasskey={false}
                        roles={VAULT_ACCESS_ROLES}
                        onRemove={onRemove}
                        onUpdate={onUpdate}
                    />
                ))}
            </Text>
        </div>
    );
};
